/**
 * The signature is chosen at DOWNLOAD, not at
 * issue. Pure decisions for the editor's download control -- `vitest` runs in
 * `node` and cannot render the dialog, so the rules live here.
 */

export type SignatureChoice = 'include' | 'omit'

/** Whether Download asks "include the signature?". A draft never prints a
 *  signature (`templates/document.html` withholds it), so it downloads
 *  straight away; an unknown status asks nothing either. */
export function asksForSignature(status: string | undefined): boolean {
  return status !== undefined && status !== 'Draft'
}

/** What a refused `?signature=include` means for the person downloading:
 *  `upload` -- they are the signer with nothing on file, so offer the upload
 *  right there; `not-signer` -- the document was issued blank and only its
 *  signer may add theirs. Null for any other error (show the server's words). */
type NoSignatureOutcome = 'upload' | 'not-signer'

export function noSignatureOutcome(error: unknown): NoSignatureOutcome | null {
  const response = (error as { response?: { status?: number; data?: unknown } } | null)?.response
  if (response?.status !== 409) return null
  const detail = (response.data as { detail?: unknown } | null | undefined)?.detail
  if (!detail || typeof detail !== 'object') return null
  const code = (detail as { code?: unknown }).code
  if (code === 'no_signature') return 'upload'
  if (code === 'not_signer') return 'not-signer'
  return null
}

/** Printing another person's signature writes the history, so the server takes it only as a POST. */
export function signedDownloadMethod(signer: string | undefined): 'get' | 'post' {
  return signer ? 'post' : 'get'
}
